// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css
// module id = 55
// module chunks = 0